export default "__VITE_ASSET__gs87LQAO__"